var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2969 12.3438C13.5385 12.3438 12.8112 12.645 12.275 13.1812C11.7388 13.7175 11.4375 14.4448 11.4375 15.2031V28.5469L18.1094 30.4531L28.5938 25.6875L31.4531 17.1094L29.5469 12.3438H14.2969Z",
    fill: "#114782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 18.0625H30.5V19.9688H22.875V18.0625Z",
    fill: "#548AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 18.0625H20.9688V19.9688H15.25V18.0625Z",
    fill: "#548AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 22.8281H28.5938V24.7344H15.25V22.8281Z",
    fill: "#548AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6094 19.2468V54.2812C48.6092 55.0395 48.3079 55.7667 47.7717 56.3029C47.2355 56.8391 46.5083 57.1404 45.75 57.1406H17.1562C16.398 57.1404 15.6708 56.8391 15.1346 56.3029C14.5984 55.7667 14.2971 55.0395 14.2969 54.2812V30.4531L29.5469 26.6406V8.53125H37.8939C38.6521 8.53191 39.3791 8.83309 39.9157 9.36881L47.7718 17.2249C48.3075 17.7615 48.6087 18.4885 48.6094 19.2468Z",
    fill: "#002145"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 48.5625H28.5938V50.4688H19.0625V48.5625Z",
    fill: "#486BE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 48.5625H37.1719V50.4688H30.5V48.5625Z",
    fill: "#486BE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0781 48.5625H44.7969V50.4688H39.0781V48.5625Z",
    fill: "#486BE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 42.8438H21.9219V44.75H19.0625V42.8438Z",
    fill: "#486BE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8281 42.8438H33.3594V44.75H23.8281V42.8438Z",
    fill: "#486BE0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 37.125H26.6875V39.0312H19.0625V37.125Z",
    fill: "#486BE0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 37.125H36.2188V39.0312H28.5938V37.125Z",
    fill: "#486BE0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 27.5938H43.8438V29.5H41.9375V27.5938Z",
    fill: "#486BE0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4531 27.5938H40.0312V29.5H31.4531V27.5938Z",
    fill: "#486BE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 21.875H43.8438V23.7812H38.125V21.875Z",
    fill: "#486BE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 21.875H36.2188V23.7812H30.5V21.875Z",
    fill: "#486BE0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2656 42.8438H41.9375V44.75H35.2656V42.8438Z",
    fill: "#486BE0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6815 29.0234L30.017 25.688L33.1142 28.7852L29.7787 32.1207L26.6815 29.0234Z",
    fill: "#F78E00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5403 32.3594L33.3522 28.5474L36.27 31.4652L32.458 35.2771L29.5403 32.3594Z",
    fill: "#E37600"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4456 36.1729L37.1634 30.455L56.223 49.5146L50.5052 55.2325L31.4456 36.1729Z",
    fill: "#F58002"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5156 55.2344L51.2375 55.9562C51.613 56.3317 52.0588 56.6296 52.5494 56.8328C53.04 57.036 53.5658 57.1406 54.0969 57.1406H54.0969C55.1693 57.1406 56.1979 56.7146 56.9562 55.9562C57.7146 55.1979 58.1406 54.1693 58.1406 53.0969V53.0969C58.1406 52.5658 58.036 52.04 57.8328 51.5494C57.6296 51.0588 57.3317 50.613 56.9562 50.2375L56.2344 49.5156L50.5156 55.2344Z",
    fill: "#E37600"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 1.85938C15.0932 1.85938 12.1448 2.75377 9.63694 4.42946C7.12909 6.10515 5.17446 8.48688 4.02022 11.2735C2.86598 14.06 2.56398 17.1263 3.15241 20.0845C3.74083 23.0427 5.19325 25.76 7.326 27.8928C9.45875 30.0255 12.176 31.4779 15.1343 32.0664C18.0925 32.6548 21.1587 32.3528 23.9453 31.1985C26.7319 30.0443 29.1136 28.0897 30.7893 25.5818C32.465 23.074 33.3594 20.1255 33.3594 17.1094C33.3594 13.0648 31.7527 9.18593 28.8928 6.326C26.0328 3.46607 22.1539 1.85938 18.1094 1.85938ZM18.1094 28.5469C15.8473 28.5469 13.6359 27.8761 11.755 26.6193C9.87416 25.3625 8.40819 23.5762 7.54251 21.4863C6.67683 19.3964 6.45033 17.0967 6.89165 14.878C7.33297 12.6594 8.42229 10.6214 10.0218 9.02184C11.6214 7.42228 13.6594 6.33296 15.878 5.89164C18.0967 5.45032 20.3964 5.67683 22.4863 6.5425C24.5763 7.40818 26.3625 8.87415 27.6193 10.755C28.8761 12.6359 29.5469 14.8473 29.5469 17.1094C29.5469 20.1428 28.3419 23.052 26.1969 25.1969C24.052 27.3419 21.1428 28.5469 18.1094 28.5469Z",
    fill: "#F58002"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.352 18.0625H40.9844C40.734 18.0626 40.4861 18.0133 40.2548 17.9175C40.0235 17.8217 39.8133 17.6813 39.6363 17.5043C39.4593 17.3273 39.3189 17.1171 39.2231 16.8858C39.1273 16.6545 39.0781 16.4066 39.0781 16.1562V8.78857C39.3899 8.93006 39.6737 9.12661 39.9157 9.3688L47.7718 17.2249C48.014 17.4669 48.2106 17.7507 48.352 18.0625Z",
    fill: "#7DAFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.770a813f381b22800b3f58684d5f3282.svg";
export { ForwardRef as ReactComponent };